import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-md mb-4 flex justify-between font-bold text-gray-900" }

import { ref } from 'vue';

import { useCurrentSegment } from '@/composables/useCurrentSegment';
import CalculationViewStepper from '../components/CalculationViewStepper.vue';
import CalculationGroupNavigation from '../components/CalculationGroupNavigation.vue';
import CalculationGroupStepper from '../components/CalculationGroupStepper.vue';
import HideInputsButton from '../components/HideInputsButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationItems',
  setup(__props) {

const { currentSegmentGroupsViews, currentSegment, navigableSegmentGroups } = useCurrentSegment();

const selectedItems = ref<{ [key: string]: number | null }>({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(navigableSegmentGroups).length > 1)
      ? (_openBlock(), _createBlock(CalculationGroupStepper, {
          key: 0,
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(currentSegmentGroupsViews)?.name) + " ", 1),
      _createVNode(HideInputsButton)
    ]),
    _createVNode(CalculationViewStepper, {
      selectedItems: selectedItems.value,
      "onUpdate:selectedItems": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
    }, null, 8, ["selectedItems"]),
    (!_unref(currentSegment)?.is_required)
      ? (_openBlock(), _createBlock(CalculationGroupNavigation, {
          key: 1,
          class: "mt-6",
          selectedItems: selectedItems.value,
          "onUpdate:selectedItems": _cache[1] || (_cache[1] = ($event: any) => ((selectedItems).value = $event))
        }, null, 8, ["selectedItems"]))
      : _createCommentVNode("", true)
  ]))
}
}

})